import React, { useEffect } from 'react'

import { FadeSwap, Loader } from '@pb/components'
import { urlHasParam, getUrlParam } from '@pb/utils'
import { compose } from 'ramda'
import { useDispatch, useSelector } from 'react-redux'

import { SELECTED_INVOICE_PARAM } from '../../constants'
import { FILTER_NAME } from '../../duck/constants'
import { operationExpandInvoiceWithQuery } from '../../duck/operations'
import selectors from '../../duck/selectors'
import EmptyState from '../EmptyState'
import FailedOrdersNotice from '../FailedOrdersNotice'
import GetStartedMessage from '../GetStartedMessage'
import ManageCard from '../ManageCard'
import MonthlyInvoiceList from '../MonthlyInvoiceList'
import OrderList from '../OrderList'
import Preferences from '../Preferences'

interface TodoProps {
  runKlarnaOp: any
  manageCardOperation?: Object
  shouldShowManageCardButton: boolean
}

const Todo: React.FC<TodoProps> = ({
  runKlarnaOp,
  manageCardOperation,
  shouldShowManageCardButton,
}) => {
  const dispatch = useDispatch()
  const isKlarnaAuthenticated = useSelector(selectors.getIsKlarnaAuthenticated)
  const orderIds = useSelector((state) => selectors.getIdsForOrderFilter(FILTER_NAME.TO_DO, state))
  const monthlyInvoiceIds = useSelector((state) =>
    selectors.getMonthlyInvoiceIdsForFilter(FILTER_NAME.TO_DO, state),
  )
  const toDoOrdersHasLoaded = useSelector((state) =>
    selectors.getHasLoadedForOrderFilter(FILTER_NAME.TO_DO, state),
  )
  const hasMonthly = !!useSelector(selectors.getMonthlySubscription)
  const monthlyInvoicesHasLoaded = useSelector(selectors.getMonthlyInvoicesHasLoaded)
  const isLoading = !toDoOrdersHasLoaded || (hasMonthly && !monthlyInvoicesHasLoaded)
  const hasOrdersFailed = useSelector((state) =>
    selectors.getErrorForOrderFilter(FILTER_NAME.TO_DO, state),
  )

  const expandInvoiceWithQuery = (invoiceId: string): void => {
    dispatch(operationExpandInvoiceWithQuery(invoiceId, FILTER_NAME.TO_DO))
  }

  useEffect(() => {
    if (!isLoading && urlHasParam(SELECTED_INVOICE_PARAM)) {
      ;(compose(expandInvoiceWithQuery, getUrlParam) as (p: string) => void)(SELECTED_INVOICE_PARAM)
    }
  }, [isLoading])

  const renderAvailableInvoices = (): any => (
    <FadeSwap flag={isLoading} placeholder={<Loader />}>
      {orderIds.length > 0 && (
        <OrderList
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ orderIds: any; runKlarnaOp: any; shouldSho... Remove this comment to see the full error message
          orderIds={orderIds}
          runKlarnaOp={runKlarnaOp}
          shouldShowLoadMoreButton={false}
          title="omni.hmxklarna.todo.tab.paylater.purchases.heading"
          filterName={FILTER_NAME.TO_DO}
        />
      )}

      {monthlyInvoiceIds.length > 0 && (
        <MonthlyInvoiceList
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ invoiceIds: any; title: string; shouldShow... Remove this comment to see the full error message
          invoiceIds={monthlyInvoiceIds}
          title="omni.hmxklarna.todo.tab.monthly.invoices.heading"
          shouldShowLoadMoreButton={false}
          filterName={FILTER_NAME.TO_DO}
        />
      )}
    </FadeSwap>
  )

  const renderEmptyState = (): any => (
    <FadeSwap flag={isLoading} placeholder={<Loader />}>
      <EmptyState />
    </FadeSwap>
  )

  const renderTabOrders = (): any => {
    if (hasOrdersFailed) {
      return <FailedOrdersNotice />
    }

    return orderIds.length || monthlyInvoiceIds.length
      ? renderAvailableInvoices()
      : renderEmptyState()
  }

  return isKlarnaAuthenticated ? (
    <>
      {renderTabOrders()}

      {shouldShowManageCardButton && <ManageCard manageCardOperation={manageCardOperation} />}

      <Preferences />
    </>
  ) : (
    <GetStartedMessage />
  )
}

export default Todo
